<template>
	<v-app>

		<Nav/>

		<v-container class="landing-description container-wrapper">

			<v-row
				class="py-12"
			>
				<v-col
					cols="12"
					class="text-center"
				>
					<h1 class="pb-6">Atlasų galerija</h1>
					<p>
						Įdomiausių viešų atlasų kolekcija sukurta geoportal.lt naudotojų taikant interaktyvų atlasų kūrimo įrankį.<br>Kurkite, dalinkitės, pristatykite savo idėjas. 
					</p>

				</v-col>

			</v-row>

			<ListFilter
				:lists="{
					interactive: listInteractive,
					printable: listPrintable
				}"
				:setFilteredLists="setFilteredLists"
				:sortable="true"
				class="mb-10"
				v-if="listInteractive && listInteractive != 'error' && listPrintable && listPrintable != 'error'"
			>
				<div class="body-2 float-right">
					<div>
						<v-btn
							icon
							v-on:click="displaySelectorExpanded = !displaySelectorExpanded"
							small
						>
							<template v-if="displaySelectorExpanded">
								<v-icon title="Suskleisti">mdi-menu-up</v-icon>
							</template>
							<template v-else>
								<v-icon title="Išskleisti">mdi-menu-down</v-icon>
							</template>
						</v-btn>
						<span class="font-weight-bold">Vaizdavimas</span>
					</div>
					<v-expand-transition>
						<v-card
							v-show="displaySelectorExpanded"
							flat
							class="pa-0"
						>
							<div class="d-flex flex-column ml-7">
								<ul class="ma-0 pa-0">
									<template
										v-for="(item, i) in displayTypes"
									>
										<li class="mb-1" :key="i">
											<template v-if="item.type == displayType">
												<span>{{item.title}}</span>
											</template>
											<template v-else>
												<a href="#" v-on:click.stop.prevent="setDisplayType(item.type)">{{item.title}}</a>
											</template>
										</li>
									</template>
								</ul>
							</div>
						</v-card>
					</v-expand-transition>
				</div>
			</ListFilter>

			<v-row
				class="pt-6"
			>
				<v-col
					cols="12"
					class="text-left"
				>
					<h3 class="pb-6">Interaktyvūs atlasai</h3>
					<p>
						Istorija papasakota žemėlapiuose, aprašymuose, nuotraukose, sujungta į vieną interaktyvų atlasų. Kuriant interaktyvius atlasus Jūs galite pasirinkti 
						skirtingus puslapio elementų išdėstymo šablonus, juose talpinti interaktyvius žemėlapius, istorijos objektų sekos žemėlapius, ar tekstinį, grafinį turinį.
					</p>

				</v-col>

			</v-row>
			
			<!-- TODO: turi būti sukurtas puslapiavimo funkcionalumas abiems (print, interactive) sąrašams -->
			<v-row
				class="pb-6"
			>

				<template v-if="interactiveLoading">
					<v-progress-circular
						indeterminate
						color="primary"
						:size="40"
						width="2"
					></v-progress-circular>
				</template>
				<template v-else>
					<template v-if="listInteractive == 'error'">
						<div>Deja, atlasų sąrašo gauti nepavyko...</div>
					</template>
					<template v-else>
						<template v-for="(atlas, i) in listInteractiveFiltered.slice(0,8)">
							<AtlasPreviewGallery
								:atlas="atlas"
								:key="atlas.atlasID"
								:class="[i ? '' : '']"
								:getList="getList"
								:displayType="displayType"
							/>
						</template>
					</template>
				</template>

			</v-row>


			<v-row
				class="pt-6"
			>
				<v-col
					cols="12"
					class="text-left"
				>
					<h3 class="pb-6">Atlasai spausdinimui</h3>
					<p>
						Kurkite žemėlapių serijas panaudodami šimtus geoportal.lt viešų žemėlapių ir spausdinkite jas. Susipažinkite su atrinktais įdomiausiais 
						spausdinimui skirtais atlasais. Kuriant spausdinimui skirtą atlasą Jūs galite ne tik pasinaudoti geoportal.lt turiniu, bet ir įsikelti savo 
						duomenis, el. paslaugas.
					</p>

				</v-col>

			</v-row>

			<v-row
				class="pb-6"
			>

				<template v-if="printableLoading">
					<v-progress-circular
						indeterminate
						color="primary"
						:size="40"
						width="2"
					></v-progress-circular>
				</template>
				<template v-else>
					<template v-if="listPrintable == 'error'">
						<div>Deja, atlasų sąrašo gauti nepavyko...</div>
					</template>
					<template v-else>
						<template v-for="(atlas, i) in listPrintableFiltered.slice(0,8)">
							<AtlasPreviewGallery
								:atlas="atlas"
								:key="i"
								:class="[i ? '' : '']"
								:getList="getList"
								:displayType="displayType"
							/>
						</template>
					</template>
				</template>

			</v-row>

		</v-container>

		<InfoCreateAtlas />

		<v-footer class="white">
			<Footer />
		</v-footer>

	</v-app>
</template>

<script>
	import Nav from "../header/PageNav";
	import Footer from "../footer/FooterTitle";
	import AtlasHelper from "../helpers/AtlasHelper";
	import AtlasPreviewGallery from "../atlas/AtlasPreviewGallery";
	import InfoCreateAtlas from "../gui-elements/InfoCreateAtlas";
	import ListFilter from "../ListFilter";

	export default {
		components: {
			Nav,
			Footer,
			AtlasPreviewGallery,
			InfoCreateAtlas,
			ListFilter
		},
		data: function(){
			var data = {
				interactiveLoading: true,
				printableLoading: true,
				listInteractive: null,
				listPrintable: null,
				listInteractiveFiltered: null,
				listPrintableFiltered: null,
				displaySelectorExpanded: false,
				displayType: "icons",
				displayTypes: [{
					type: "icons",
					title: "Piktogramos"
				},{
					type: "table",
					title: "Lentelė"
				}]
			};
			return data;
		},
		created(){
			this.getList();
		},
		methods: {
			getList: function(){
				this.interactiveLoading = this.printableLoading = true;

				AtlasHelper.getPublicListByFilter("interactive", location.host == "www.geoportal.lt" ? "geoportal_admin" : "Svecias1").then(function(listInteractive){
					this.interactiveLoading = false;
					this.listInteractive = this.listInteractiveFiltered = listInteractive;
				}.bind(this), function(){
					this.interactiveLoading = false;
					this.listInteractive = "error";
				}.bind(this));

				AtlasHelper.getPublicListByFilter("printable", location.host == "www.geoportal.lt" ? "geoportal_admin" : "Svecias1").then(function(listPrintable){
					this.printableLoading = false;
					this.listPrintable = this.listPrintableFiltered = listPrintable;
				}.bind(this), function(){
					this.printableLoading = false;
					this.listPrintable = "error";
				}.bind(this));

			},
			setFilteredLists: function(lists){
				this.listInteractiveFiltered = lists.interactive;
				this.listPrintableFiltered = lists.printable;
			},
			setDisplayType: function(displayType){
				this.displayType = displayType;
			}
		}
	};
</script>

<style scoped>
	li {
		list-style-type: none;
	}
</style>